export enum TipoItem {
    Produto = 1,
    Opcao = 2,
    Adicional = 3
}